import {
    closeTeamModal,
    deleteTeam,
    editTeam,
    openTeamModal,
    saveTeam,
} from './teams';
import { showSettingsView, wireSettingsNav } from './ui';

let wired = false;

export function initSettingsView(): void {
    showSettingsView('teams');

    if (!wired) {
        wireSettingsNav();
        wired = true;
    }

    const settingsEl = document.getElementById('settings');
    if (!settingsEl || settingsEl.dataset.wired === 'true') {
        return;
    }

    settingsEl.dataset.wired = 'true';
    settingsEl.addEventListener('click', (e) => {
        const btn = (e.target as HTMLElement).closest('[data-action]') as HTMLElement | null;
        if (!btn) return;

        const action = btn.getAttribute('data-action');
        const id = btn.getAttribute('data-id');

        switch (action) {
            case 'openTeamModal':
                openTeamModal();
                break;
            case 'saveTeam':
                saveTeam();
                break;
            case 'editTeam':
                if (id) editTeam(Number(id));
                break;
            case 'deleteTeam':
                if (id) deleteTeam(Number(id));
                break;
            case 'closeTeamModal':
                closeTeamModal();
                break;
            default:
                return;
        }
        e.preventDefault();
    });

    if (!(window as any)._settingsModalHandlerAdded) {
        document.addEventListener(
            'click',
            (e: MouseEvent) => {
                const btn = (e.target as HTMLElement).closest('[data-action]') as HTMLElement | null;
                if (!btn) return;

                const action = btn.getAttribute('data-action');
                switch (action) {
                    case 'saveTeam':
                        saveTeam();
                        break;
                    case 'closeTeamModal':
                        closeTeamModal();
                        break;
                    default:
                        return;
                }
                e.stopPropagation();
                e.preventDefault();
            },
            true,
        );
        (window as any)._settingsModalHandlerAdded = true;
    }
}
